import { gql } from '@apollo/client';

export const DELETE_SCHEDULE_TYPE_CELL_PARAM_TEMPLATE = gql`
  mutation removeScheduleTypeCellParamTemplate($input: DeleteScheduleTypeCellParamTemplateInput) {
    removeScheduleTypeCellParamTemplate(input: $input) {
      commandId
      correlationId
    }
  }
`;
